/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Private_Models_Form_Vllm_Model_Name_DescriptionInputs */



/**
* | output |
* | --- |
* | "The model name as configured in VLLM." |
*
* @param {Private_Models_Form_Vllm_Model_Name_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const private_models_form_vllm_model_name_description = /** @type {((inputs?: Private_Models_Form_Vllm_Model_Name_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Private_Models_Form_Vllm_Model_Name_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Der Modellname wie in VLLM konfiguriert.")
	return /** @type {LocalizedString} */ ("The model name as configured in VLLM.")
});